import {BaseService} from './baseService.js';
import {Service} from './service.js';

/**
 * Handles media
 */
export class MediaService extends BaseService {
	
	static get properties() {		
		return {			
		};
	}
	
	constructor() {	
		super();
	}
	
	async getAllMedia() {
		var data = await this.makeGETRequest('/api/resource/media');
		return data;
	}
	
	async deleteMedia(mediaId) {
		var results = await this.makeDELETERequest('/api/resource/media/' + mediaId);
		return results;
	}
	
}

